<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-dialog modal-dialog-centered modal-lg w-100" role="document">
      <div class="modal-content radius-8">
        <div class="d-flex align-items-center justify-content-between">
          <h5 class="modal-title" id="sizeGuideModalLabel">{{ title }}</h5> <button type="button" class="close" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body p-0 my-3">
          <div class="text-center">
            <p class="alert-text m-0">{{ message }}</p> </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: { // New prop for modal title
        type: String,
        default: 'Limit Exceeded'
      },
      message: { // New prop for modal message
        type: String,
        default: 'You have exceeded a quantity limit.' // Default message
      }
    },
    methods: {
      closeModal() {
        this.$emit('close');
      }
    }
  };
</script>

<style scoped>
/* Add your modal overlay and modal content styles here */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050; /* Ensure it's above other content */
}

.modal-dialog {
  max-width: 500px; /* Adjust as needed */
  margin: 1.75rem auto;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
  background-color: transparent;
  border: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}

.close:hover {
  opacity: 0.75;
}

.radius-8 {
  border-radius: 8px !important;
}

.alert-text {
  font-size: 16px;
  color: #4F2D2CE5;
}
</style>
